<template>
	<div class="icon-button" @click="$emit('click', $event)">
		<div class="icon-button__label" v-if="label">{{ label }}</div>
		<svgicon class="icon-button__icon" v-if="icon" :icon="icon" />
		<div v-if="badge > 0" class="badge">{{ badge }}</div>
	</div>
</template>

<script>
	import ButtonView from './ButtonView'

	export default {
		extends: ButtonView,
		props: {
			icon: {
				type: String,
				required: true
			},
			badge: {
				type: Number,
				default: 0
			}
		}
	}
</script>

<style>
	.icon-button {
		position: relative;
		cursor: pointer;
	}

	.icon-button > .badge {
		position: absolute;
		top: 10px;
		right: 5px;
		background-color: #f7223f;
		color: white;
		border-radius: 50%;
		width: 20px;
		line-height: 20px;
		text-align: center;
		font-size: 10px;
	}

	.icon-button__icon {
		position: absolute;
		width: 18px;
		height: 18px;
		top: 50%;
		left: 50%;
		margin-top: -8px;
		margin-left: -8px;
		fill: #15161a;
	}
</style>
